var isHighlightedBlock = function isHighlightedBlock(block) {
  return (block === null || block === void 0 ? void 0 : block.getData().get('highlighted')) === true;
};

export default isHighlightedBlock;